// @ts-expect-error module is untyped
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { useQuery } from 'data-fetching-client';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import { useMemo } from 'react';
import { GET_SEARCH_TAGS } from '../../../queries/searchTagQuery';
import { jsx as _jsx } from "react/jsx-runtime";
const LoadingComponent = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  size: "extra-small"
});
const SearchTagFilter = ({
  disabled,
  offeringType,
  onChange,
  scrollable = true,
  value
}) => {
  const {
    loading,
    error,
    data,
    previousData
  } = useQuery(GET_SEARCH_TAGS, {
    variables: {
      offeringType
    }
  });
  const searchTagsOptions = useMemo(() => {
    const searchTagsData = data || previousData;
    if (!searchTagsData) {
      return [];
    }
    const {
      searchTags: {
        tags
      }
    } = searchTagsData;
    if (!tags) {
      return [];
    }
    return tags.map(item => ({
      text: item,
      value: item
    })).sort((a, b) => localeComparator(a.text, b.text));
  }, [data, previousData]);
  const searchTagsRequestState = useMemo(() => {
    if (loading) {
      return RequestState.PENDING;
    }
    if (error) {
      return RequestState.FAILED;
    }
    if (!data && !previousData) {
      return RequestState.UNINITIALIZED;
    }
    return RequestState.SUCCEEDED;
  }, [data, error, loading, previousData]);
  return /*#__PURE__*/_jsx(LoadingWrapper, {
    LoadingComponent: LoadingComponent,
    requestStatus: searchTagsRequestState,
    children: /*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.searchTags.title'),
      disabled: disabled,
      multi: true,
      name: ThemeQueryField.TAGS,
      onChange: onChange,
      options: searchTagsOptions,
      scrollable: scrollable,
      searchable: true,
      value: value,
      virtualized: scrollable
    })
  });
};
export default SearchTagFilter;